import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { getNotificationHint } from '../requests';
import type { GetNotificationHintRequestType } from '../types';

export const useGetNotificationHint = (
  { pathParams: { notificationId } }: GetNotificationHintRequestType,
  options?: {
    enabled?: boolean;
  },
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.notificationHint, { notificationId }],
    queryFn: () => getNotificationHint({ pathParams: { notificationId } }),
    ...options,
  });
